import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'

export default class ProjectGanttTaskService {
    constructor() {
        this.apis = {
            getAll: () => axios.get(APIConfig.APIURL + '/projectGanttTask'),
            add: (payload) => axios.post(APIConfig.APIURL + '/projectGanttTask', payload),
            edit: (id, payload) => axios.put(APIConfig.APIURL + `/projectGanttTask/${id}`, payload),
            inActivate: (id) => axios.post(APIConfig.APIURL + `/projectGanttTask/${id}/inactivate`),
            // delete: (id) => axios.delete(APIConfig.APIURL + `/projectGanttTask/${id}`),
            getByProject: (projectID) => axios.get(APIConfig.APIURL + `/projectGanttTask`, { params: { 'project': projectID } }),
            finish: (id) => axios.post(APIConfig.APIURL + `/projectGanttTask/${id}/finish`),
        }
    }

    prepareData(vm) {
        return new Promise((resolve, reject) => {
            if (vm.$store.state.projectGanttTask.isFetched) {
                resolve(vm.$store.state.projectGanttTask.list)
                return
            }
            if (vm.$store.state.projectGanttTask.isFetching) {
                var timer = setInterval(() => {
                    if (vm.$store.state.projectGanttTask.isFetching) return
                    clearInterval(timer)
                    if (vm.$store.state.projectGanttTask.isFetched) {
                        resolve(vm.$store.state.projectGanttTask.list)
                    } else {
                        reject('無法取得資料，請嘗試重新整理')
                    }
                }, 500)
                return
            }
            return this.getAll(vm)
                .then(res => {
                    vm.$store.state.projectGanttTask.isFetched = true
                    vm.$store.state.projectGanttTask.isReloaded = false
                    vm.$store.state.projectGanttTask.list = res.data.result || []
                    return res
                })
                .then(res => {
                    vm.$store.state.projectGanttTask.isFetching = false
                    resolve()
                    return res
                })
                .catch(err => {
                    vm.$store.state.projectGanttTask.isFetching = false
                    reject(err)
                })
        })
    }

    getAll(vm) {
        return new Promise((resolve, reject) => {
            this.apis.getAll()
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    add(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.add(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    edit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.edit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    inActivate(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.inActivate(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    delete(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.delete(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    getByProject(vm, projectID) {
        return new Promise((resolve, reject) => {
            this.apis.getByProject(projectID)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    finish(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.finish(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }
}
